/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetKeysRequest} from '@cash-web/protos/squareup/hieroglyph/service.pb'
import {GetKeysResponse} from '@cash-web/protos/squareup/hieroglyph/service.pb'


export const getKeys = (request: GetKeysRequest, options?: CashRequestOptions) => post<GetKeysRequest, GetKeysResponse>("/2.0/cash/get-keys", request, {...options, rejectOnError: true })